import React from 'react'

import { ZariContext } from '_zari/context'

import { Portlet, Table } from '_zari/core'

import * as CodigosTransaccionesConstant from 'constants/codigosTransacciones'

import * as TempInventarioCrud from 'services/tempInventario.service'

const portletBreadcrumbs = [{ name: 'Ingreso Manual' }]

const SaldosInicialesListaPage = ({ history }) => {
  const __zariContext = React.useContext(ZariContext)

  const tablaRef = React.useRef(null)

  const clickEditarHandler = React.useCallback(
    async ({ _id }) => {
      history.push(`/${CodigosTransaccionesConstant.INVENTARIOS_INGRESOMANUAL_EDITAR}/${_id}`)
    },
    [history]
  )

  const clickEliminarHandler = React.useCallback(
    async ({ _id }) => {
      TempInventarioCrud.eliminarTempInventario(_id)
        .then(({ data }) => {
          __zariContext.snack('success', 'El registro se ha eliminado.')
          tablaRef.current.reload()
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext]
  )

  const clickNuevoHandler = e => {
    e.preventDefault()
    history.push(`/${CodigosTransaccionesConstant.INVENTARIOS_INGRESOMANUAL_NUEVO}`)
  }

  return (
    <>
      <Portlet>
        <Portlet.Header title='Ingreso Manual' breadcrumbs={portletBreadcrumbs} buttons={[{ name: 'Nuevo', onClick: clickNuevoHandler }]} />
        <Portlet.Body>
          <Table.ServerSide
            ref={tablaRef}
            useNest={true}
            url='/kardex-temporal'
            headRows={[{ label: 'TITULO' }, { label: '' }]}
            rowTemplate={row => (
              <Table.Row hover key={row._id}>
                <Table.Cell>{row.titulo || '--'}</Table.Cell>
                <Table.Cell>
                  <Table.Dropdown>
                    {({ handleClose }) => [
                      <Table.Dropdown.Item key='editar' handleClose={handleClose} onClick={e => clickEditarHandler({ _id: row._id })}>
                        Editar
                      </Table.Dropdown.Item>,
                      <Table.Dropdown.Item key='eliminar' handleClose={handleClose} onClick={e => clickEliminarHandler({ _id: row._id })}>
                        Eliminar
                      </Table.Dropdown.Item>
                    ]}
                  </Table.Dropdown>
                </Table.Cell>
              </Table.Row>
            )}
          />
        </Portlet.Body>
      </Portlet>
    </>
  )
}

export default SaldosInicialesListaPage
